import React, { useState } from 'react';
import { IconButton, Stack, Tooltip } from '@mui/joy';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownOutlinedIcon from '@mui/icons-material/ThumbDownOutlined';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';

const MessageActions = ({
  content,
  messageId,
  feedback,
  onFeedback,
  feedbackLoading,
  showFeedback = true,
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(content);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <Stack
      direction="row"
      gap={0.5}
      sx={{
        opacity: 0,
        transition: 'opacity 0.2s ease',
        '.message-container:hover &': {
          opacity: 1,
        },
      }}
    >
      {/* Copy Button */}
      <Tooltip title={copied ? 'Copied!' : 'Copy'} placement="top">
        <IconButton
          size="sm"
          variant="plain"
          color={copied ? 'success' : 'neutral'}
          onClick={handleCopy}
          sx={{ '--IconButton-size': '28px' }}
        >
          {copied ? (
            <CheckIcon sx={{ fontSize: 16 }} />
          ) : (
            <ContentCopyIcon sx={{ fontSize: 16 }} />
          )}
        </IconButton>
      </Tooltip>

      {/* Feedback Buttons */}
      {showFeedback && messageId && (
        <>
          <Tooltip title="Good response" placement="top">
            <IconButton
              size="sm"
              variant="plain"
              color={feedback === 'like' ? 'success' : 'neutral'}
              onClick={() => onFeedback?.('like')}
              disabled={feedbackLoading}
              sx={{ '--IconButton-size': '28px' }}
            >
              {feedback === 'like' ? (
                <ThumbUpIcon sx={{ fontSize: 16 }} />
              ) : (
                <ThumbUpOutlinedIcon sx={{ fontSize: 16 }} />
              )}
            </IconButton>
          </Tooltip>
          <Tooltip title="Bad response" placement="top">
            <IconButton
              size="sm"
              variant="plain"
              color={feedback === 'dislike' ? 'danger' : 'neutral'}
              onClick={() => onFeedback?.('dislike')}
              disabled={feedbackLoading}
              sx={{ '--IconButton-size': '28px' }}
            >
              {feedback === 'dislike' ? (
                <ThumbDownIcon sx={{ fontSize: 16 }} />
              ) : (
                <ThumbDownOutlinedIcon sx={{ fontSize: 16 }} />
              )}
            </IconButton>
          </Tooltip>
        </>
      )}
    </Stack>
  );
};

export default MessageActions;
